module.exports = __webpack_public_path__ + "static/img/icon_fhdj.c21e4b3f.png";